/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from "../../framework/API/api"
import BossDialog from "../../components/BossDialog";
import { EditPageHeader } from "../../components/EditPageHeader";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { BOOLEAN_STATUS, ENTITYNAME, LOGEVENT, MODULE } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import { toast } from "react-toastify";

const TranscodePrototypeEditForm = (props) => {
    const lang = useTranslation();
    const blankDataItem = {
        ...props?.item,
        SID: props?.item?.SID ?? 0,
        Description: props?.item?.copy ? 'copy of ' + props?.item?.Description : props?.item?.Description ?? '',
        TitleFlag: props?.item?.TitleFlag ? { _id: props?.item?.TitleFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props?.item?.TitleFlag) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
        LogoFlag: props?.item?.LogoFlag ? { _id: props?.item?.LogoFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props?.item?.LogoFlag) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
        LogoOpposite: props?.item?.LogoOpposite ? { _id: props?.item?.LogoOpposite, Description: utility.getKeyByValue(BOOLEAN_STATUS, props?.item?.LogoOpposite) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
        EndingFlag: props?.item?.EndingFlag ? { _id: props?.item?.EndingFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props?.item?.EndingFlag) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
        Definition: props?.item?.Definition,
        ReverseAudioChannelFlag: props?.item?.ReverseAudioChannelFlag ? { _id: props?.item?.ReverseAudioChannelFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props?.item?.ReverseAudioChannelFlag) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
        TagFlag: props?.item?.TagFlag ? { _id: props?.item?.TagFlag, Description: utility.getKeyByValue(BOOLEAN_STATUS, props?.item?.TagFlag) } : { _id: BOOLEAN_STATUS.false, Description: utility.getKeyByValue(BOOLEAN_STATUS, BOOLEAN_STATUS.false) },
        AudioMode: props?.item?.AudioMode,
        Archive: props?.item?.Archive ?? false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [transcodeDefinitions, setTranscodeDefinitions] = useState([]);
    const [booleans, setBooleans] = useState([]);

    useEffect(() => {
        loadcombo();
    }, [])

    const loadcombo = async () => {
        let booleansRes = Object.keys(BOOLEAN_STATUS).map((x) => {
            return {
                _id: BOOLEAN_STATUS[x],
                Description: x
            }
        })
        setBooleans(booleansRes);

        const transcodeDefinitionsRes = await API.getDataLookup(ENTITYNAME.TranscodeDefinition, { sort: { Description: 1 } });
        setTranscodeDefinitions(transcodeDefinitionsRes.data);
        setDataItem({ ...dataItem, Definition: (props?.item?.Definition && Object.keys(props?.item?.Definition)?.length > 0) ? props?.item?.Definition : utility.getDefaultItem(transcodeDefinitionsRes.data) });
    }

    const onChange = (e) => {

        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    function validationCheck() {

        if (dataItem.Description == undefined || dataItem.Description.trim().length == 0 || dataItem.Description == "") {
            toast.error(`${lang.please_enter_description_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {

        if (validationCheck()) {
            const saveData = {
                _id: dataItem?._id,
                SID: dataItem?.SID ?? 0,
                Description: dataItem?.Description,
                TitleFlag: dataItem?.TitleFlag?._id,
                LogoFlag: dataItem?.LogoFlag?._id,
                LogoOpposite: dataItem?.LogoOpposite?._id,
                EndingFlag: dataItem?.EndingFlag?._id,
                Definition: dataItem?.Definition && Object.keys(dataItem?.Definition).length > 0 ? {
                    _id: dataItem?.Definition?._id,
                    Description: dataItem?.Definition?.Description
                } : {},
                ReverseAudioChannelFlag: dataItem?.ReverseAudioChannelFlag?._id,
                TagFlag: dataItem?.TagFlag?._id,
                AudioMode: dataItem?.AudioMode ?? "",
                Archive: dataItem?.Archive ?? false,
            }
            console.log(saveData);

            let res = await API.saveData(ENTITYNAME.TranscodePrototypes, saveData);
            if (res.success) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.TRANSCODE_PROTOTYPES, data: res.data, message: res.message };
                API.SaveLogs(logData);
                utility.deleteLocalStorageItem(ENTITYNAME.TranscodePrototypes);
                props.cancelEdit();
                props.refresh();
            }
            else {
                toast.error(res.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    }

    return (
        <BossDialog
            title={props?.item?.SID > 0 ? props?.item?.Description : lang.transcode_Prototypes_header}
            onClose={props.cancelEdit}
            width={"900px"}
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className="row mt-2">
                <div className="col-12">
                    <div className="row">
                        <div className="col-6">
                            <label>{lang.description_label} *</label>
                            <input
                                name="Description"
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.Description}
                            />
                        </div>
                        <div className="col-6" >
                            <label>{lang.title_flag_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={booleans}
                                name="TitleFlag"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.TitleFlag}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-6" >
                            <label>{lang.logo_flag_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={booleans}
                                name="LogoFlag"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.LogoFlag}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-6" >
                            <label>{lang.logo_opposite_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={booleans}
                                name="LogoOpposite"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.LogoOpposite}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-6" >
                            <label>{lang.ending_flag_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={booleans}
                                name="EndingFlag"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.EndingFlag}
                                onChange={onChange}
                            />
                        </div>

                        <div className="col-6" >
                            <label>{lang.definition_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={transcodeDefinitions}
                                name="Definition"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.Definition}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-6" >
                            <label>{lang.reverse_audio_channel_flag_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={booleans}
                                name="ReverseAudioChannelFlag"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.ReverseAudioChannelFlag}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-6" >
                            <label>{lang.tag_flag_label}</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={booleans}
                                name="TagFlag"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.TagFlag}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-6" >
                            <label>{lang.audio_mode_label}</label>
                            <input
                                name="AudioMode"
                                className="form-control form-control-sm"
                                value={dataItem.AudioMode}
                                type="input"
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-6" style={{ marginTop: "22px" }}>
                            <input type={"checkbox"} name={"Archive"}
                                onChange={(e) => onChange(e)}
                                value={dataItem.Archive}
                                checked={dataItem.Archive} />
                            <label className="ml-1">{lang.archive}</label>
                        </div>
                    </div>
                </div>
            </div>
        </BossDialog>
    )
}

export default TranscodePrototypeEditForm